package us.laantech.laanmanage.ui

import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import us.laantech.laanmanage.feature.login.LoginView
import us.laantech.laanmanage.feature.lpa.LossPreventionView
import us.laantech.laanmanage.feature.reports.department.ui.DepartmentReportView
import us.laantech.laanmanage.feature.reports.tax.ui.TaxReportView
import us.laantech.laanmanage.feature.reports.z.ui.ZReportView
import us.laantech.laanmanage.feature.settings.tax.TaxSetupView
import us.laantech.laanmanage.feature.store.department.StoreDepartmentsView
import us.laantech.laanmanage.feature.store.inventory.InventoryManagementView
import us.laantech.laanmanage.feature.store.pos.ui.PosEditorView
import us.laantech.laanmanage.feature.store.settings.StoreSettingsView


data class MenuItem(
    val title: String,
    val destination: @Composable () -> Unit,
)

data class MenuSection(
    val title: String,
    val items: List<MenuItem>,
)

val MAIN_MENU = listOf(
    MenuSection(
        title = "Debug",
        items = listOf(
            MenuItem(title = "Login", destination = { LoginView() }),
            MenuItem(title = "Date Time Entry", destination = { Text("Item 2") }),
        )
    ),

    MenuSection(
        title = "Reports",
        items = listOf(
            MenuItem(title = "KPI", destination = { Text("Item 2") }),
            MenuItem(title = "Department", destination = { DepartmentReportView() }),
            MenuItem(title = "Product", destination = { Text("Item 2") }),
            MenuItem(title = "Tax", destination = { TaxReportView() }),
            MenuItem(title = "SKU Not Found", destination = { Text("Item 2") }),
            MenuItem(title = "Z Report", destination = { ZReportView() }),
        )
    ),

    MenuSection(
        title = "Company Management",
        items = listOf(
            MenuItem(title = "Company Overview", destination = { Text("Item 2") }),
            MenuItem(title = "Taxes and Fees", destination = { TaxSetupView() }),
        )
    ),

    MenuSection(
        title = "Store Management",
        items = listOf(
            MenuItem(title = "Store Settings", destination = { StoreSettingsView() }),
            MenuItem(title = "Store Inventory", destination = { Text("Item 2") }),
            MenuItem(title = "POS Management", destination = { PosEditorView() }),
            MenuItem(title = "Departments", destination = { StoreDepartmentsView() }),
            MenuItem(title = "Tag Setup", destination = { Text("Item 2") }),
            MenuItem(title = "Promotion Setup", destination = { Text("Item 2") }),
            MenuItem(title = "Units and Measures", destination = { Text("Item 2") }),
            MenuItem(title = "Loyalty Setup", destination = { Text("Item 2") }),
            MenuItem(title = "POS Terminal", destination = { Text("Item 2") }),
        )
    ),

    MenuSection(
        title = "Inventory & Financial",
        items = listOf(
            MenuItem(title = "Inventory On Hand", destination = { InventoryManagementView() }),
            MenuItem(title = "Invoice By Vendor", destination = { Text("Item 2") }),
            MenuItem(title = "Inventory Audit", destination = { Text("Item 2") }),
            MenuItem(title = "Lottery Inventory", destination = { Text("Item 2") }),
            MenuItem(title = "Low Stock Alert", destination = { Text("Item 2") }),
        )
    ),

    MenuSection(
        title = "Loss Prevention",
        items = listOf(
            MenuItem(title = "Loss Prevention", destination = { LossPreventionView() }),
        )
    ),

    MenuSection(
        title = "Employee Management",
        items = listOf(
            MenuItem(title = "Time Clock and Shifts", destination = { Text("Item 2") }),
            MenuItem(title = "Employee Directory", destination = { Text("Item 2") }),
            MenuItem(title = "Customer Accounts", destination = { Text("Item 2") }),
            MenuItem(title = "User Roles", destination = { Text("Item 2") }),
            MenuItem(title = "Audit Report", destination = { Text("Item 2") }),
        )
    ),

    MenuSection(
        title = "Settings",
        items = listOf(MenuItem(title = "Settings", destination = { Text("Item 2") }))
    )
)
